import _ from 'lodash'
export function findTag(tags: any[], namespace: string[]) {
  const _namespace = `${namespace.join('.')}\\.`
  const regExp = new RegExp(`^${_namespace}(.*)`)

  return _.find(tags, tag => regExp.test(tag.pathname))
}
